import type { SVGProps } from "react";

const Gray = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="220" height="199" viewBox="0 0 220 199" fill="none" {...props}>
    <ellipse cx="110" cy="105.658" rx="75.2632" ry="75.2632" fill="url(#paint0_linear_1328_308)" />
    <g filter="url(#filter0_dd_1328_308)">
      <path
        d="M33.5553 138.4L48.6632 131.605C51.2911 130.422 54.1659 129.893 57.0426 130.061C59.9193 130.23 62.7126 131.092 65.1843 132.573L68.7171 134.701C73.3451 137.475 78.6396 138.94 84.0354 138.94C89.4311 138.94 94.7256 137.475 99.3537 134.701L101.307 133.526C104.083 131.859 107.261 130.978 110.5 130.978C113.739 130.978 116.917 131.859 119.693 133.526L121.646 134.701C126.274 137.475 131.569 138.94 136.965 138.94C142.36 138.94 147.655 137.475 152.283 134.701L155.816 132.573C158.287 131.092 161.081 130.23 163.957 130.061C166.834 129.893 169.709 130.422 172.337 131.605L187.445 138.4C188.161 138.748 188.94 138.949 189.735 138.99C190.53 139.032 191.326 138.914 192.074 138.642C192.823 138.371 193.51 137.952 194.094 137.411C194.678 136.87 195.147 136.217 195.474 135.491C195.801 134.765 195.98 133.98 195.998 133.184C196.017 132.388 195.876 131.596 195.583 130.856C195.291 130.115 194.852 129.441 194.294 128.873C193.736 128.304 193.07 127.854 192.335 127.548L177.219 120.744C172.84 118.773 168.049 117.89 163.254 118.172C158.46 118.454 153.805 119.892 149.687 122.364L146.154 124.483C143.379 126.151 140.202 127.032 136.965 127.032C133.727 127.032 130.55 126.151 127.775 124.483L125.814 123.308C121.188 120.534 115.895 119.069 110.5 119.069C105.105 119.069 99.8122 120.534 95.1857 123.308L93.2248 124.483C90.4497 126.151 87.2731 127.032 84.0354 127.032C80.7977 127.032 77.6211 126.151 74.846 124.483L71.3132 122.364C67.1951 119.892 62.5402 118.454 57.7459 118.172C52.9515 117.89 48.1601 118.773 43.7807 120.744L28.6649 127.548C27.9298 127.854 27.2636 128.304 26.7057 128.873C26.1478 129.441 25.7095 130.115 25.4168 130.856C25.1241 131.596 24.9829 132.388 25.0016 133.184C25.0203 133.98 25.1986 134.765 25.5257 135.491C25.8529 136.217 26.3223 136.87 26.9063 137.411C27.4903 137.952 28.1769 138.371 28.9256 138.642C29.6743 138.914 30.4697 139.032 31.265 138.99C32.0602 138.949 32.839 138.748 33.5553 138.4ZM116.454 21.8322V5.95424C116.454 4.37508 115.827 2.86059 114.71 1.74396C113.594 0.627319 112.079 0 110.5 0C108.921 0 107.406 0.627319 106.29 1.74396C105.173 2.86059 104.546 4.37508 104.546 5.95424V21.8322C104.546 23.4114 105.173 24.9259 106.29 26.0425C107.406 27.1591 108.921 27.7865 110.5 27.7865C112.079 27.7865 113.594 27.1591 114.71 26.0425C115.827 24.9259 116.454 23.4114 116.454 21.8322Z"
        fill="url(#paint1_linear_1328_308)"
      />
    </g>
    <g filter="url(#filter1_dd_1328_308)">
      <path
        d="M55.8083 63.2341L102.831 45.6016C107.775 43.7436 113.225 43.7436 118.169 45.6016L165.192 63.2341L153.64 25.6906C152.767 22.8494 151.006 20.363 148.616 18.5968C146.225 16.8306 143.331 15.8777 140.359 15.878H80.6415C77.6691 15.8777 74.7751 16.8306 72.3844 18.5968C69.9937 20.363 68.2325 22.8494 67.3595 25.6906L55.8083 63.2341ZM130.347 31.756H122.408C120.829 31.756 119.315 32.3833 118.198 33.4999C117.082 34.6166 116.454 36.131 116.454 37.7102C116.454 39.2894 117.082 40.8039 118.198 41.9205C119.315 43.0371 120.829 43.6645 122.408 43.6645H130.347C131.927 43.6645 133.441 43.0371 134.558 41.9205C135.674 40.8039 136.302 39.2894 136.302 37.7102C136.302 36.131 135.674 34.6166 134.558 33.4999C133.441 32.3833 131.927 31.756 130.347 31.756ZM98.5915 31.756H90.6525C89.0733 31.756 87.5589 32.3833 86.4422 33.4999C85.3256 34.6166 84.6983 36.131 84.6983 37.7102C84.6983 39.2894 85.3256 40.8039 86.4422 41.9205C87.5589 43.0371 89.0733 43.6645 90.6525 43.6645H98.5915C100.171 43.6645 101.685 43.0371 102.802 41.9205C103.918 40.8039 104.546 39.2894 104.546 37.7102C104.546 36.131 103.918 34.6166 102.802 33.4999C101.685 32.3833 100.171 31.756 98.5915 31.756Z"
        fill="url(#paint2_linear_1328_308)"
      />
    </g>
    <g filter="url(#filter2_dd_1328_308)">
      <path
        d="M48.695 110.9C57.8645 109.089 67.38 110.75 75.3938 115.56L78.9346 117.68C82.0705 119.561 86.0003 119.561 89.1441 117.68L91.0971 116.505C96.9575 112.986 103.664 111.128 110.5 111.128C117.336 111.128 124.042 112.986 129.903 116.505L131.856 117.68C135 119.561 138.93 119.561 142.065 117.68L145.606 115.56C153.62 110.75 163.135 109.089 172.305 110.9L177.91 89.8617C178.798 86.5302 178.415 82.9876 176.836 79.9225C175.258 76.8574 172.596 74.4888 169.368 73.2772L115.375 53.0327C112.232 51.8501 108.768 51.8501 105.625 53.0327L51.6324 73.2772C48.4045 74.4888 45.7424 76.8574 44.1637 79.9225C42.5849 82.9876 42.2022 86.5302 43.09 89.8617L48.695 110.9Z"
        fill="url(#paint3_linear_1328_308)"
      />
    </g>
    <circle cx="30.3947" cy="57.8947" r="7.23684" fill="white" />
    <ellipse cx="26.0527" cy="188.158" rx="10.1316" ry="10.1316" fill="white" />
    <ellipse cx="209.868" cy="81.0526" rx="10.1316" ry="10.1316" fill="white" />
    <ellipse cx="193.947" cy="41.9737" rx="5.78947" ry="5.78947" fill="white" />

    <defs>
      <filter
        id="filter0_dd_1328_308"
        x="8.33333"
        y="0"
        width="204.333"
        height="172.332"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="3.33333" operator="erode" in="SourceAlpha" result="effect1_dropShadow_1328_308" />
        <feOffset dy="6.66667" />
        <feGaussianBlur stdDeviation="3.33333" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.04 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1328_308" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="3.33333" operator="erode" in="SourceAlpha" result="effect2_dropShadow_1328_308" />
        <feOffset dy="16.6667" />
        <feGaussianBlur stdDeviation="10" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_1328_308" result="effect2_dropShadow_1328_308" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1328_308" result="shape" />
      </filter>
      <filter
        id="filter1_dd_1328_308"
        x="39.1416"
        y="15.878"
        width="142.717"
        height="80.6894"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="3.33333" operator="erode" in="SourceAlpha" result="effect1_dropShadow_1328_308" />
        <feOffset dy="6.66667" />
        <feGaussianBlur stdDeviation="3.33333" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.04 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1328_308" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="3.33333" operator="erode" in="SourceAlpha" result="effect2_dropShadow_1328_308" />
        <feOffset dy="16.6667" />
        <feGaussianBlur stdDeviation="10" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_1328_308" result="effect2_dropShadow_1328_308" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1328_308" result="shape" />
      </filter>
      <filter
        id="filter2_dd_1328_308"
        x="25.9549"
        y="52.1458"
        width="169.09"
        height="100.279"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="3.33333" operator="erode" in="SourceAlpha" result="effect1_dropShadow_1328_308" />
        <feOffset dy="6.66667" />
        <feGaussianBlur stdDeviation="3.33333" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.04 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1328_308" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="3.33333" operator="erode" in="SourceAlpha" result="effect2_dropShadow_1328_308" />
        <feOffset dy="16.6667" />
        <feGaussianBlur stdDeviation="10" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_1328_308" result="effect2_dropShadow_1328_308" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1328_308" result="shape" />
      </filter>
      <filter
        id="filter3_b_1328_308"
        x="74"
        y="117"
        width="72"
        height="72"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="4" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1328_308" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1328_308" result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear_1328_308"
        x1="110"
        y1="30.3947"
        x2="110"
        y2="180.921"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F3EDFA" />
        <stop offset="1" stopColor="#EBEAED" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1328_308"
        x1="114.186"
        y1="6.4866"
        x2="182.323"
        y2="177.937"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9FAFB" />
        <stop offset="1" stopColor="#E4E7EC" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1328_308"
        x1="151.158"
        y1="23.1635"
        x2="145.53"
        y2="63.1521"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9FAFB" />
        <stop offset="1" stopColor="#E4E7EC" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1328_308"
        x1="160.961"
        y1="62.445"
        x2="151.951"
        y2="118.651"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9FAFB" />
        <stop offset="1" stopColor="#E4E7EC" />
      </linearGradient>
    </defs>
  </svg>
);

export const IllustrationShip = { Gray };
